function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
var selectedStyles = function selectedStyles(hasError, theme) {
  return {
    borderColor: hasError === 'yes' ? theme.palette.secondary.main : theme.palette.primaryAlt.main,
    color: '#fff',
    background: hasError === 'yes' ? theme.palette.secondary.main : theme.palette.primaryAlt.main,
    '&:hover': {
      background: hasError === 'yes' ? theme.palette.secondary.dark : theme.palette.primaryAlt.dark
    }
  };
};
var unselectedStyles = function unselectedStyles(error, theme) {
  return {
    borderColor: error === 'yes' ? theme.palette.secondary.main : theme.palette.primaryAlt.main,
    color: error === 'yes' ? theme.palette.secondary.main : theme.palette.primaryAlt.main
  };
};
var requiredUnselectedStyles = function requiredUnselectedStyles(selected, theme) {
  return {
    borderColor: !selected ? theme.palette.secondary.main : theme.palette.primaryAlt.main,
    color: !selected ? theme.palette.secondary.main : theme.palette.primaryAlt.main
  };
};
var borderRadiusStyles = function borderRadiusStyles(edges, theme) {
  if (edges === 'rounded') {
    return 99;
  }
  if (edges === 'sharp') {
    return 0;
  }
  return theme.shape.borderRadius;
};
export var StyledButton = styled(Button)(function (_ref) {
  var error = _ref.error,
    indeterminate = _ref.indeterminate,
    required = _ref.required,
    selected = _ref.selected,
    theme = _ref.theme;
  return _extends({}, !selected && required && _extends({}, requiredUnselectedStyles(selected, theme), {
    '&:hover, &:active, &:focus': _extends({}, requiredUnselectedStyles(selected, theme))
  }), !selected && !required && _extends({}, unselectedStyles(error, theme), {
    '&:hover, &:active, &:focus': _extends({}, unselectedStyles(error, theme))
  }), selected && indeterminate === 'no' && selectedStyles(error, theme));
});
export var StyledButtonGroup = styled(ButtonGroup)(function (_ref2) {
  var edges = _ref2.edges,
    theme = _ref2.theme;
  return {
    '& .MuiButtonBase-root': {
      borderRadius: borderRadiusStyles(edges, theme),
      '&:first-child': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      '&:last-child': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  };
});